import { Slide } from '@/components/core/Slide';
import audioFile from './25-pragmatic-transition.mp3';

const autoNextDuration = 22000;
const transcript = `
  Ik praat teveel... En ik stop even met de videobeelden want ik zie dat het veel afleidt.

  We kunnen nog uren praten over al deze fascinerende technologieën en toekomstbeelden, maar ik denk 
  dat het tijd is voor wat meer pragmatische tips nu.

  Laten we kijken naar concrete stappen die jullie als technische bedrijven vandaag al kunnen zetten 
  om klaar te zijn voor de toekomst.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-10">Tijd voor Praktische Tips</h1>
        <div className="text-3xl space-y-8">
          <p>We kunnen nog uren praten over fascinerende technologieën...</p>
          <p className="text-4xl font-semibold">Maar laten we praktisch worden.</p>
          <p>
            Wat kun je <span className="underline">vandaag</span> al doen?
          </p>
        </div>
      </div>
    </Slide>
  );
};
